import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axiosAuth from "../../axiosAuth";
import { BOM_POSITION_API } from "../apiRoutes";

interface UseGetPropertyOwnerProps {
  communityId: string;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getPropertyOwner = async (communityId: string) =>
  await axiosAuth.get(`${BOM_POSITION_API}/community/${communityId}`);

const useGetPropertyOwner = ({
  communityId,
  queryParams,
}: UseGetPropertyOwnerProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["bom-position", communityId],
    queryFn: () => getPropertyOwner(communityId),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
  });
};

export default useGetPropertyOwner;
